/**
 * @module components\ghTable\dataTable\dataRow
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Inject, Watch } from "vue-property-decorator";
import DataCell from "./dataCell/dataCell";

@Component({
  components: {
    DataCell
  }
})
export default class DataRow extends Vue {
  @Inject()
  private bus: Vue;

  @Prop()
  private headers!: ITableHeader[];

  @Prop()
  private props!: ITableRowProps;

  @Prop()
  private beforeIntial: (
    props: ITableRowProps
  ) => { [key: string]: ITableRowOption };

  private options: { [key: string]: ITableRowOption } = {};

  private clickRow(props) {
    props.selected = true;
  }

  private get Headers() {
    if (this.headers) {
      return this.headers.filter(h => !h.hide);
    }
  }

  private getCellClass(h: ITableHeader) {
    if (h.align) {
      return "text-xs-" + h.align;
    }
    return null;
  }
  @Watch("props.item")
  private observe() {
    if (this.beforeIntial) {
      this.options = this.beforeIntial(this.props);
    }
  }

  created() {
    if (this.beforeIntial) {
      this.options = this.beforeIntial(this.props);
    }
  }
}
